import { VForm } from 'vuetify/lib/components/VForm';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"value":_vm.isModalOpen,"title":"Create Client Profile","isLoading":_vm.isLoading},on:{"click:outside":_vm.closeDialog},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('qvoButton',{attrs:{"text":""},on:{"click":_vm.clickSecondaryButton}},[_vm._v(_vm._s(_vm.step === 2 ? "Back" : "Cancel"))]),_c('qvoButton',{attrs:{"disabled":!_vm.isFormValid},on:{"click":_vm.clickPrimaryButton}},[_vm._v("\n      "+_vm._s(_vm.step === 2 ? "Create" : "Next")+"\n    ")])]},proxy:true}])},[(_vm.step === 1)?_c('h6',[_vm._v("Basic Client Info")]):_vm._e(),(_vm.step === 2)?_c('h6',[_vm._v("Client Address")]):_vm._e(),_c(VForm,{ref:"form",staticClass:"fields",model:{value:(_vm.isFormValid),callback:function ($$v) {_vm.isFormValid=$$v},expression:"isFormValid"}},_vm._l((_vm.layout.modalSteps[_vm.step]),function(row,key){return _c('div',{key:key,staticClass:"field-row"},_vm._l((row),function(field){return _c('div',{key:_vm.getFieldDataValue({ id: field.id, value: 'FieldId' }),staticClass:"field",style:(`grid-column: ${field.column || 1} / span ${
          field.columnWidth || 4
        }`)},[(field.specialField === 'ClientId')?_c('string',{staticClass:"special-field",attrs:{"id":"Client ID","label":_vm.getFieldDataValue({
              id: 'ClientId',
              category: 'Info',
              value: 'Label',
            }) || 'Client ID',"placeholder":_vm.getFieldDataValue({
              id: 'ConfigLabel',
              category: 'Info',
              value: 'Placeholder',
            }) ||
            _vm.getFieldDataValue({
              id: 'ClientId',
              category: 'Info',
              value: 'Label',
            }) ||
            'Client ID',"value":_vm.clientId,"rules":_vm.clientIdRegex},on:{"setConfigValue":_vm.setClientId}}):_vm._e(),(field.specialField === 'ConfigLabel')?_c('string',{staticClass:"special-field",attrs:{"id":"Config Label","category":"Info","label":_vm.getFieldDataValue({
              id: 'ConfigLabel',
              category: 'Info',
              value: 'Label',
            }),"placeholder":_vm.getFieldDataValue({
              id: 'ConfigLabel',
              category: 'Info',
              value: 'Placeholder',
            }) ||
            _vm.getFieldDataValue({
              id: 'ConfigLabel',
              category: 'Info',
              value: 'Label',
            }),"value":_vm.getConfigValue({ id: 'ConfigLabel', category: 'Info' }),"rules":[{ Type: 'required' }]},on:{"setConfigValue":(value) =>
              _vm.setConfigValue({
                category: 'Info',
                fieldId: 'ConfigLabel',
                value,
              })}}):_c('configField',{attrs:{"id":"New","category":"ClientInformation","field":_vm.getFieldData({ id: field.id }),"value":_vm.getConfigValue({ id: field.id }),"isInModal":""},on:{"setConfigValue":_vm.setConfigValue}})],1)}),0)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }